import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './app-config.model';
import { FEATURE_FLAGS } from '../enums/feature-flags.enum';
import { GoogleTagManagerConfiguration } from 'angular-google-tag-manager';

@Injectable()
export class AppConfigService {
	static settings: AppConfig;
	static getSettings(): AppConfig {
		return AppConfigService.settings;
	}
	static isFeatureFlagEnabled(feature: FEATURE_FLAGS): boolean {
		return AppConfigService.settings.featureFlags[feature] === 'true';
	}

	static isNewLandingPageEnabled(clientId: number): boolean {
		// Hard-coded exclusion: always disable landing page for clientID -100
		if (clientId === -100) {
			return false;
		}
		
		return !AppConfigService.settings.featureFlags[FEATURE_FLAGS.DISABLE_LANDING_PAGE_CLIENT_IDS]
			?.split(',')
			?.map(Number)
			?.includes(clientId);
	}

	static isNewProfilePageEnabled(clientId: number): boolean {
		return AppConfigService.settings.featureFlags[FEATURE_FLAGS.NEW_TUITION_PROFILE_PAGE_CLIENT_IDS]
			?.split(',')
			?.map(Number)
			?.includes(clientId);
	}

	static isNewBenefitsAndSupportPageEnabled(clientId: number): boolean {
		return AppConfigService.settings.featureFlags[FEATURE_FLAGS.NEW_TUITION_BENEFITS_AND_SUPPORT_PAGE_CLIENT_IDS]
			?.split(',')
			?.map(Number)
			?.includes(clientId);
	}

	static featureFlagForClientIds(feature: FEATURE_FLAGS, clientId: number): boolean {
		return AppConfigService.settings.featureFlags[feature]?.split(',')?.map(Number)?.includes(clientId);
	}

	constructor(private readonly http: HttpClient) {}
	async load(environmentName: string, gtmConfig: GoogleTagManagerConfiguration): Promise<AppConfig> {
		const jsonFile = `assets/config/config.${environmentName}.json`;

		return new Promise<AppConfig>((resolve, reject) => {
			this.http
				.get(jsonFile)
				.toPromise()
				.then((response: any) => {
					AppConfigService.settings = response;
					if (AppConfigService.settings.env.gtmContainerId && gtmConfig) {
						gtmConfig.set({ id: AppConfigService.settings.env.gtmContainerId });
					}
					resolve(response);
				})
				.catch((response: any) => {
					reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
				});
		});
	}
}
